// Generated types for PrivateNode
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { NeoNodeReadAPI, NeoNodeWriteAPI } from './neonode';
import { NeoNodeReadAPISchemaObject, NeoNodeWriteAPISchemaObject } from './neonode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface PrivateNodeReadAPI extends NeoNodeReadAPI {
}

export interface PrivateNodeWriteAPI extends NeoNodeWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const PrivateNodeReadAPISchemaObject = NeoNodeReadAPISchemaObject.extend({}).passthrough();
export const PrivateNodeReadAPISchema: z.ZodType<PrivateNodeReadAPI> = PrivateNodeReadAPISchemaObject;

export const PrivateNodeWriteAPISchemaObject = NeoNodeWriteAPISchemaObject.extend({}).passthrough();
export const PrivateNodeWriteAPISchema: z.ZodType<PrivateNodeWriteAPI> = PrivateNodeWriteAPISchemaObject;
